import apiClient from '../services/apiClient'
import { serverFile } from '../services/file.service'
import { DocumentModel } from '../types/document.type'

export const getAll = async (lng: string) => {
    const data = (await apiClient.post('/documents/all', { lng })).data as DocumentModel[]
    return data.map((doc) => ({ ...doc, file: doc.file.includes('http') ? doc.file : serverFile(doc.file) }))
}

export const getAllMemberDocuments = async (lng: string) => {
    const data = (await apiClient.post('/documents/all/member', { lng }, { params: { role: 'ROLE_MEMBER' } }))
        .data as DocumentModel[]
    return data.map((doc) => ({ ...doc, file: doc.file.includes('http') ? doc.file : serverFile(doc.file) }))
}

export const getAllAdminDocuments = async (lng: string) => {
    const data = (await apiClient.post('/documents/all/admin', { lng }, { params: { role: 'ROLE_ADMIN' } }))
        .data as DocumentModel[]
    return data.map((doc) => ({ ...doc, file: doc.file.includes('http') ? doc.file : serverFile(doc.file) }))
}

export const deleteDocumentById = async (id: number) => {
    const data = (await apiClient.delete(`/documents/${id}`, { params: { role: 'ROLE_ADMIN' } })).data
    return data
}
